export const AUTO_LINK_CUSTOMER_NOT_FOUND = 'Microsoft_Dynamics_Commerce_Runtime_CustomerNotFound_WhenAutoLinking';

// Error identifier returned by the retail server when a customer's external identity is not mapped
export const COMMERCE_CUSTOMER_IDENTITY_NOT_FOUND = 'Microsoft_Dynamics_Commerce_Runtime_CommerceCustomerIdentityNotFound';
